import React, { useState } from "react";
import styles from "./DepositModal.module.scss";
import { useTranslations } from "next-intl";
import { useStore } from "@/hooks/use-store";

import { useGetPaymentSystems } from "@/domains/profile/hooks/use-get-payment-systems";
import DepositHeader from "@/domains/profile/components/deposit-header";
import DepositFooter from "@/domains/profile/components/deposit-footer";
import DepositTab from "@/domains/profile/components/deposit-tab";
import Image from "next/image";
import { moneyFormat } from "@/utils/moneyFormat";
import { getSymbolByCurrency } from "@/utils/currencies";

export default function DepositModal() {
  const t = useTranslations("DepositModal");
  const { user } = useStore();
  const { paymentSystems } = useGetPaymentSystems();
  const [selectedType, setSelectedType] = useState<"in" | "out">("in");

  const handlerSelectedType = (_selectedType: "in" | "out") => {
    setSelectedType(_selectedType);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <DepositHeader onClick={handlerSelectedType} type={selectedType} />

        <div className={styles.flexPay}>
          <p>{t("balance")}:</p>
          <div className={styles.balanceInner}>
            <span className={styles.balanceInnerAmount}>
              {moneyFormat(user.user?.balance.amount || 0).replace("$", "")}
            </span>
            <div className={styles.balanceCurrency}>
              {user?.isCrypto() ? (
                <>
                  <span className={styles.balanceCurrencySymbol}>
                    <Image
                      src="/images/icons/tether-usdt-logo.svg"
                      alt="Bazz"
                      width={21}
                      height={21}
                      quality={100}
                    />
                  </span>
                  <span className={styles.balanceCurrencyText}>USDT</span>
                </>
              ) : (
                <>
                  <span className={styles.balanceCurrencySymbolFiat}>
                    {getSymbolByCurrency(user.user?.balance.currency)}
                  </span>
                  <span className={styles.balanceCurrencyText}>{user.user?.balance.currency}</span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {selectedType === "out" ? (
        <div className={styles.flexPay_type}>{t("selectedTypeOUT")}:</div>
      ) : (
        <div className={styles.flexPay_type}>{t("selectedTypeIN")}:</div>
      )}

      <DepositTab paymentSystems={paymentSystems?.[selectedType] ?? []} type={selectedType} />

      <DepositFooter />
    </div>
  );
}
